import React from 'react';
import Testimonial from '../../Components/Testimonial/Testimonial';
const Reviews = () => {
    return (
        <div>
            <Testimonial/>
        </div>
    );
};

export default Reviews;